import * as React from 'react';
import * as FontAwesome from 'react-fontawesome';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { invoicesActionCreators } from '../../data/invoices/invoicesAction';
import { ApiInvoiceObject, ApiInvoiceRowObject, ApiInvoicesState } from '../../data/invoices/invoicesModels';
// tslint:disable-next-line:no-var-requires
const invoices = require('../../resources/invoices.png');
import * as moment from 'moment';
import { connect, Dispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../components/table/table';
import { DataType, RowObject, Tbody } from '../../components/table/tableModels';
import * as Client from '../../data/apiClient/client';

// tslint:disable-next-line:no-var-requires
const html2pdf = require('html2pdf.js');

type InvoiceProps = InvoiceState & // ... state we've requested from the Redux store
    InvoiceActions & // ... plus action creators we've requested
    RouteComponentProps<{ id: string }>;

interface InvoiceState {
    header: HeaderState;
    invoices: ApiInvoicesState;
}

interface InvoiceActions {
    headerActions: typeof headerActionCreators;
    invoicesActions: typeof invoicesActionCreators;
}

interface State {
    id: string | undefined;
    invoice: ApiInvoiceObject | undefined;
    tHead: Array<RowObject>;
}

class Invoice extends React.PureComponent<InvoiceProps, State> {
    constructor(props: InvoiceProps) {
        super(props);
        this.state = {
            id: undefined,
            invoice: undefined,
            tHead: [
                new RowObject(DataType.string, 'Line Number', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Item Number', undefined, undefined, 'pointer'),
                // new RowObject(DataType.string, 'Description', undefined, undefined, 'pointer'),
                new RowObject(DataType.number, 'Ordered Qty', undefined, undefined, 'pointer'),
                new RowObject(DataType.number, 'Delivered Qty', undefined, undefined, 'pointer'),
                new RowObject(DataType.number, 'Backorder Qty', undefined, undefined, 'pointer'),
                new RowObject(DataType.number, 'Unit Price', undefined, undefined, 'pointer'),
                new RowObject(DataType.number, 'Discount', undefined, undefined, 'pointer'),
                new RowObject(DataType.number, 'Amount', undefined, undefined, 'pointer')
            ]
        };
        this.getTheInvoice = this.getTheInvoice.bind(this);
        this.renderTheBody = this.renderTheBody.bind(this);
        this.saveOrderAsPdf = this.saveOrderAsPdf.bind(this);
    }

    componentWillMount() {
        this.getTheInvoice(this.props.match.params.id);
    }

    saveOrderAsPdf() {
        const logoHtml = document.getElementsByClassName('headerLogoPadding');
        const htmlData = document.getElementById('invoicedata');
        if (
            logoHtml !== undefined &&
            logoHtml !== null &&
            htmlData !== undefined &&
            htmlData !== null &&
            htmlData.firstChild !== null &&
            this.state.invoice !== undefined
        ) {
            const opt = {
                margin: 5,
                pagebreak: { mode: 'avoid-all' },
                filename: 'Invoice_' + this.state.invoice.invoiceNumber + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 5 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            };
            const html = logoHtml[0].outerHTML + '<br><br><br><br><br><br><br>' + htmlData.outerHTML;
            html2pdf().set(opt).from(html).save();
        } else {
            alert('Error');
        }
    }

    getTheInvoice(id: string) {
        const invoiceClient = new Client.InvoicesClient();
        if (id !== this.state.id) {
            invoiceClient.get(id).then((res) => {
                this.setState({
                    id: id,
                    invoice: new ApiInvoiceObject(
                        res.invoiceId ? res.invoiceId : undefined,
                        res.invoiceNumber ? res.invoiceNumber : undefined,
                        res.dueDate ? res.dueDate : undefined,
                        res.orderNumber ? res.orderNumber : undefined,
                        res.balance ? res.balance : undefined,
                        res.orderId ? res.orderId : undefined,
                        res.pONumber ? res.pONumber : undefined,
                        res.invoiceDate ? res.invoiceDate : undefined,
                        res.totalAmount ? res.totalAmount : undefined,
                        res.taxAmount ? res.taxAmount : undefined,
                        res.shipToName ? res.shipToName : undefined,
                        res.shipToAddress ? res.shipToAddress : undefined,
                        res.shipToCity ? res.shipToCity : undefined,
                        res.shipToState ? res.shipToState : undefined,
                        res.freightAmount ? res.freightAmount : undefined,
                        res.productAmount ? res.productAmount : undefined,
                        res.materialSurchange ? res.materialSurchange : undefined,
                        res.miscChanges ? res.miscChanges : undefined,
                        res.invoiceRows
                            ? res.invoiceRows.map((obj) => {
                                  return new ApiInvoiceRowObject(
                                      obj.lineNumber ? obj.lineNumber : undefined,
                                      obj.itemNumber ? obj.itemNumber : undefined,
                                      obj.orderedQty ? obj.orderedQty : undefined,
                                      obj.deliveredQty ? obj.deliveredQty : undefined,
                                      obj.backorderQty ? obj.backorderQty : undefined,
                                      obj.unitPrice ? obj.unitPrice : undefined,
                                      obj.discount ? obj.discount : undefined,
                                      obj.amount ? obj.amount : undefined,
                                      obj.description ? obj.description : undefined
                                  );
                              })
                            : undefined,
                        res.customerName,
                        res.address,
                        res.city,
                        res.state,
                        res.country
                    )
                });
            });
        }
    }

    renderTheBody() {
        if (this.state.invoice !== undefined && this.state.invoice.invoiceRows) {
            return this.state.invoice.invoiceRows.map((obj) => {
                const rBody = new Array<RowObject>();

                rBody.push(
                    new RowObject(DataType.string, obj.lineNumber ? obj.lineNumber : '', null, undefined, undefined)
                );

                rBody.push(
                    new RowObject(DataType.string, obj.itemNumber ? obj.itemNumber : '', null, undefined, undefined)
                );

                // rBody.push(
                //     new RowObject(DataType.string, obj.description ? obj.description : '', null, undefined, undefined)
                // );

                rBody.push(
                    new RowObject(
                        DataType.number,
                        obj.orderedQty
                            ? obj.orderedQty.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                              })
                            : '0',
                        null,
                        undefined,
                        undefined
                    )
                );
                rBody.push(
                    new RowObject(
                        DataType.number,
                        obj.deliveredQty ? obj.deliveredQty : '0',
                        null,
                        undefined,
                        undefined
                    )
                );
                rBody.push(
                    new RowObject(
                        DataType.number,
                        obj.backorderQty ? obj.backorderQty : '0',
                        null,
                        undefined,
                        undefined
                    )
                );
                rBody.push(
                    new RowObject(
                        DataType.number,
                        obj.unitPrice
                            ? obj.unitPrice.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                              })
                            : '0',
                        null,
                        undefined,
                        undefined
                    )
                );
                rBody.push(
                    new RowObject(
                        DataType.number,
                        obj.discount
                            ? obj.discount.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                              })
                            : '0',
                        null,
                        undefined,
                        undefined
                    )
                );
                rBody.push(
                    new RowObject(
                        DataType.number,
                        obj.amount
                            ? obj.amount.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                              })
                            : '0',
                        null,
                        undefined,
                        undefined
                    )
                );

                return new Tbody(
                    rBody,
                    undefined,
                    undefined,
                    obj.description ? { lable: '', description: obj.description } : undefined
                );
            });
        } else {
            const rBody = new Array<RowObject>();
            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            return [new Tbody(rBody)];
        }
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Invoice'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={invoices} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    className="btn pdf-btn float-right"
                    onClick={this.saveOrderAsPdf}
                    disabled={this.state.invoice === undefined}
                    id="pdf-btn"
                >
                    <i className="fa fa-file-pdf-o fa-2x" />
                </button>
                {this.state.invoice !== undefined ? (
                    <div className="container-fluid" id="invoicedata">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Customer:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.customerName}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Address:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.address}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">City:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.city}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">State:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.state}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Country:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.country}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Invoice Number:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.invoiceNumber}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Invoice Date:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>
                                                    {this.state.invoice.invoiceDate
                                                        ? moment(this.state.invoice.invoiceDate, 'M/D/YYYY').format(
                                                              'M/D/YYYY'
                                                          )
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Due Date:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>
                                                    {this.state.invoice.dueDate
                                                        ? moment(this.state.invoice.dueDate, 'M/D/YYYY').format(
                                                              'M/D/YYYY'
                                                          )
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Order Number:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.orderNumber}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">PO Number:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.poNumber}</div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="tileHead bold">Shipping Information:</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Company Name:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.shiptoname}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Address:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.shiptoaddress}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">City:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.shiptocity}</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">State:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>{this.state.invoice.shiptostate}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Total Amount:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>
                                                    {this.state.invoice.totalAmount
                                                        ? this.state.invoice.totalAmount.toLocaleString(undefined, {
                                                              minimumFractionDigits: 2,
                                                              maximumFractionDigits: 2
                                                          })
                                                        : '0'}
                                                </div>
                                                {/* }    <button 
                                            className="btn btn-outline-secondary float-right"
                                            onClick={this.saveOrderAsPdf}
                                        >
                                            <i className="fa fa-file-pdf"/>
                                        </button> */}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Product Amount:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>
                                                    {this.state.invoice.productAmount
                                                        ? this.state.invoice.productAmount.toLocaleString(undefined, {
                                                              minimumFractionDigits: 2,
                                                              maximumFractionDigits: 2
                                                          })
                                                        : '0'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Freight Amount:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>
                                                    {this.state.invoice.freightAmount
                                                        ? this.state.invoice.freightAmount.toLocaleString(undefined, {
                                                              minimumFractionDigits: 2,
                                                              maximumFractionDigits: 2
                                                          })
                                                        : '0'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Material Surcharge:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>
                                                    {this.state.invoice.materialSurchargeAmount
                                                        ? this.state.invoice.materialSurchargeAmount.toLocaleString(
                                                              undefined,
                                                              {
                                                                  minimumFractionDigits: 2,
                                                                  maximumFractionDigits: 2
                                                              }
                                                          )
                                                        : '0'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Tax Amount:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>
                                                    {this.state.invoice.taxAmount
                                                        ? this.state.invoice.taxAmount.toLocaleString(undefined, {
                                                              minimumFractionDigits: 2,
                                                              maximumFractionDigits: 2
                                                          })
                                                        : '0'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="bold">Misc Charges:</div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div>
                                                    {this.state.invoice.miscChargesAmount
                                                        ? this.state.invoice.miscChargesAmount.toLocaleString(
                                                              undefined,
                                                              {
                                                                  minimumFractionDigits: 2,
                                                                  maximumFractionDigits: 2
                                                              }
                                                          )
                                                        : '0'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">&nbsp;</div>
                                        </div>
                                        {
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="bold">Balance:</div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div>
                                                        {this.state.invoice.balance
                                                            ? this.state.invoice.balance.toLocaleString(undefined, {
                                                                  minimumFractionDigits: 2,
                                                                  maximumFractionDigits: 2
                                                              })
                                                            : '0'}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row topMargin">
                            <div className="col-sm-12">
                                {this.state.invoice.invoiceRows ? (
                                    <Table
                                        tHead={this.state.tHead}
                                        tBody={this.renderTheBody()}
                                        listSize={this.state.invoice.invoiceRows.length}
                                        hover={true}
                                        cursor={true}
                                        hidePagination={true}
                                        americanDateFormat={true}
                                    />
                                ) : (
                                    <div>Rows missing</div>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): InvoiceState {
    return {
        header: state.header,
        invoices: state.invoices
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): InvoiceActions {
    return {
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        invoicesActions: bindActionCreators(invoicesActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Invoice)
);



// WEBPACK FOOTER //
// ./src/containers/invoice/invoice.tsx